import { render, staticRenderFns } from "./AjustesView.vue?vue&type=template&id=9b8dcaf6&lang=es"
import script from "./AjustesView.vue?vue&type=script&lang=js"
export * from "./AjustesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports